/* global $: false */
(function (window, document, $, _) {
    'use strict';

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    var el,
        previousTop,

        app = {
            init: function () {
                el = {
                    win: $(window)
                };
                app.bindUIActions();
                app.initHelpBoxes();
                app.initSmoothScrolling();
                app.initAlertInformationDialog();
                app.initSlideOutMenu();
                app.initCustomerInformationFormValidation();
                previousTop = window.pageYOffset;
            },

            bindUIActions: function bindUIActionsFn() {



                $('.js-toggle-price-info').click(function () {
                    $(this.querySelector('.js-Prices-info')).toggle();
                });

                $(window).on('scroll', _.throttle(app.headerSlideDown, 100));

                if ($.contains(document, $("#SubmenuAnchor")[0]) &&
                    $.contains(document, $("#anchor")[0]) === false &&
                    ($(window).width() < 768)) {
                    app.mobileScroll($("#SubmenuAnchor").offset().top, 800);
                } else if ($.contains(document, $("#SubmenuAnchor")[0]) &&
                    $.contains(document, $("#anchor")[0]) &&
                    ($(window).width() < 768)) {
                    app.mobileScroll($("#SubmenuAnchor").offset().top + $("#SubmenuAnchor").height(), 800);
                }
            },


            // --------------------------------
            // Initializers
            // --------------------------------

            
            initCustomerInformationFormValidation: function initCustomerInformationFormValidationFn() {
                var $infoForm = $('.js-Information-form');
                if ($infoForm.length > 0) {
                    var $informationInput = $('.js-Information-input');
                    var $informationSelect = $('.js-Information-select');
                    var $informationRadio = $('.js-Information-radio');
                    var $initInfo = [];
                    var $initInfo2 = [];
                    var $informationRadioState = '';
                    var $infoRegretBtn = $('.js-Information-regret-btn');
                    var $infoSaveContainer = $('.js-Information-save-container');
                    var $saveButton = $('.js-Information-save-btn');
                    var $saveButtonSpinner = $('.js-Information-save-btn .loading-spinner-wrapper');
                    var $infoFieldRequired = $('.js-Information-field-required');
                    var formValid;

                    $infoFieldRequired.click(function () {
                        $(this).toggleClass('is-visible');
                    });

                    $informationInput.each(function () {
                        $initInfo.push($(this).val());
                    });

                    $informationSelect.each(function () {
                        $initInfo2.push($(this).val());
                    });

                    $informationRadio.each(function () {
                        if ($(this).is(':checked')) {
                            $informationRadioState = $(this).val();
                        }
                    });

                    $informationInput.on('input', function () {
                        if ($infoSaveContainer.hasClass('is-visible') === false) {
                            $infoSaveContainer.addClass('is-visible');
                        }
                    });
                    $informationSelect.on('change', function () {
                        if ($infoSaveContainer.hasClass('is-visible') === false) {
                            $infoSaveContainer.addClass('is-visible');
                        }
                    });
                    $informationRadio.on('change', function () {
                        if ($infoSaveContainer.hasClass('is-visible') === false) {
                            $infoSaveContainer.addClass('is-visible');
                        }
                    });
                    $infoRegretBtn.click(function () {
                        $informationInput.each(function (i) {
                            $informationInput[i].value = $initInfo[i];
                            // trigger validations
                            $informationInput[i].dispatchEvent(new Event('input'));
                        });
                        $informationSelect.each(function (i) {
                            $informationSelect[i].value = $initInfo2[i];
                        });
                        $informationRadio.each(function (i) {
                            if ($informationRadio[i].value === $informationRadioState) {
                                $informationRadio[i].checked = true;
                            }
                        });
                        $infoSaveContainer.removeClass('is-visible');
                    });
                    $saveButton.click(function (e) {
                        e.preventDefault();
                        formValid = true;
                        $informationInput.each(function () {
                            if (this.classList.contains('has-error')) {
                                formValid = false;
                                $("html, body").animate({ scrollTop: $(this).offset().top - 125 }, 600);
                                $(this).focus();
                                return false;
                            }
                        });
                        if (formValid) {
                            if ($saveButtonSpinner) {
                                $saveButtonSpinner.css({ display: 'inline-block' });
                            }
                            $infoForm.submit();
                        }
                    });

                    KombiApp.Validations.addCellphoneValidation(document.getElementById('CustomerInformation_CellPhone'));
                    KombiApp.Validations.addEmailValidation(document.getElementById('CustomerInformation_Email'))
                }

            },
            
            initAlertInformationDialog: function initAlertInformationDialogFn() {
                // Check if alert message is set
                var alertId = $('.alert-banner-container').data('alertId');
                if (document.cookie.indexOf('_alertInformation_' + alertId) === -1) {
                    $('.alert-banner-container').show();
                }
                // Approve hide alert info
                $('.alert-banner-approve-btn').click(function () {
                    $('.alert-banner-container').fadeOut('fast');
                    setCookie('_alertInformation_' + alertId, 1, 2);
                });
            },


            initHelpBoxes: function initHelpBoxesFn() {
                $('.js-Information-toggle-mail').click(function (evt) {
                    evt.preventDefault();
                    $('.js-Information-help-box--mail').slideToggle();
                });

                $('.js-Information-toggle-phone').click(function (evt) {
                    evt.preventDefault();
                    $('.js-Information-help-box--phone').slideToggle();
                });

                $('.js-Information-toggle-mobile').click(function (evt) {
                    evt.preventDefault();
                    $('.js-Information-help-box--mobile').slideToggle();
                });

                $('.js-Login-username-toggle').click(function (evt) {
                    evt.preventDefault();
                    $('.js-Login-username-help-box').slideToggle();
                });

                $('.js-Login-password-toggle, .js-Login-forgot-password').click(function (evt) {
                    evt.preventDefault();
                    $('.js-login-slide-login').slideToggle();
                    $('.js-login-slide-forgotten-password').slideToggle();
                    app.checkEmailForgottenPassword();
                });

                $('.js-Login-back-btn').click(function () {
                    $('.js-login-slide-forgotten-password').slideToggle();
                    $('.js-login-slide-login').slideToggle();
                });

                $('.js-Campaign-hero-products-img').click(function () {
                    $('.js-Campaign-overlay-container').fadeIn('fast');
                    $('.js-Site-container').toggleClass('locked');
                });

                $('.js-Campaign-open-terms').click(function () {
                    $('.js-Campaign-terms-container').fadeIn('fast');
                    $('.js-Site-container').toggleClass('locked');
                });

                $('.js-open-direct-debit-terms').click(function () {
                    $('.js-direct-debit-terms-container').fadeIn('fast');
                    $('.js-Site-container').toggleClass('locked');
                });

                $('.js-billecta-terms').click(function () {
                    $('.js-billecta-terms-container').fadeIn('fast');
                    $('.js-Site-container').toggleClass('locked');
                });

                $('.js-Campaign-open-privacy-terms').click(function () {
                    $('.js-Campaign-privacy-terms-container').fadeIn('fast');
                    $('.js-Site-container').toggleClass('locked');
                });

                $('.js-Campaign-clickarea, .js-Campaign-close-form').click(function () {
                    $('.js-Campaign-overlay-container').fadeOut('fast');

                    $('.js-Campaign-terms-container').fadeOut('fast');
                    $('.js-direct-debit-terms-container').fadeOut('fast');
                    $('.js-Campaign-privacy-terms-container').fadeOut('fast');
                    $('.js-billecta-terms-container').fadeOut('fast');

                    $('.js-Site-container').toggleClass('locked');
                });

                $('#try-again').click(function () {
                    window.location.replace(window.location.href);
                });
            },

            initSlideOutMenu: function initSlideOutMenuFn() {

                $('.header-menu-button').on('click', app.toggleMenu);
                $('.js-Menu-overlay').click('click', app.toggleMenu);

                $('.js-Menu-level-one-header, .js-Menu-level-two-header').click(function () {
                    $(this).next().slideToggle();
                    $(this).toggleClass('children-open');
                });

            },

            initSmoothScrolling: function initSmoothScrollingFn() {
                $('a[href*="#"]:not([href="#"])').click(function () {
                    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                        var target = $(this.hash);
                        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            $('html, body').animate({
                                scrollTop: target.offset().top - 165
                            }, 500);
                            return false;
                        }
                    }
                    return true;
                });
            },

            // --------------------------------
            // Event Handlers
            // --------------------------------
            headerSlideDown: function headerSlideDownFn() {
                //var previousTop = window.pageYOffset;
                var headerContainer = $('.js-Header-container');
                if (window.pageYOffset > 0) { // <-- Man är inte högst upp på sidan
                    var currentOffTop = window.pageYOffset;
                    if (currentOffTop > previousTop && window.pageYOffset > 130) {
                        headerContainer.addClass('is-hidden');
                    }
                    else {
                        headerContainer.removeClass('is-hidden');
                    }
                    previousTop = currentOffTop;
                }
                else {
                    headerContainer.removeClass('is-hidden');
                }
            },

            // --------------------------------
            // Functions
            // --------------------------------
            
            mobileScroll: function mobileScrollFn(distance, delay) {
                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: distance
                    }, 400);
                }, delay);
            },


            toggleMenu: function toggleMenuFn() {
                var menuText = $('.js-Header-title--menu');

                $('.js-Menu-container').toggleClass('Menu--open');
                $('.js-Site-container').toggleClass('locked');
                $('.header-menu-button').toggleClass('Burger--open');
                $('.header-menu-button').toggleClass('active');

                if (menuText.text() === 'Meny') {
                    menuText.text('Stäng');
                } else {
                    menuText.text('Meny');
                }
            },
           

            luhnMod10: function luhnMod10Fn(number) {
                var factor = 1, sum = 0, i, addend;
                for (i = number.length - 1; i >= 0; i--) {
                    addend = factor * parseInt(number.substr(i, 1), 10);
                    factor = factor === 2 ? 1 : 2;
                    sum += parseInt((addend / 10) + (addend % 10), 10);
                }
                return sum % 10 === 0;
            },
            validatePersonalIdentityNumber: function validatePersonalIdentityNumberFn(number, format) {
                if (typeof number !== 'string') {
                    return false;
                }
                var n = number.replace(/\D/g, '');
                if (!(n.length === 12 || n.length === 10) || this.luhnMod10(n.substr(n.length - 10, 10)) === false) {
                    return false;
                }
                var months = { 1: 31, 2: 29, 3: 31, 4: 30, 5: 31, 6: 30, 7: 31, 8: 31, 9: 30, 10: 31, 11: 30, 12: 31 },
                    month = parseInt(n.substr(n.length - 8, 2), 10),
                    day = parseInt(n.substr(n.length - 6, 2), 10);
                if ((month < 1 || month > 12) || (day < 1 || day > months[month])) {
                    return false;
                }
                var now = new Date(),
                    y = now.getFullYear(),
                    sep = number.substr(-5, 1) === '+' ? '+' : '-';
                if (n.length === 10) {
                    var input_year = parseInt(n.substr(0, 2), 10),
                        century = parseInt(y.toString().substr(0, 2), 10),
                        year_2di = parseInt(y.toString().substr(2, 2), 10);
                    century -= input_year > year_2di ? 1 : 0;
                    century -= sep === '+' ? 1 : 0;
                    n = century.toString().concat(n);
                }
                switch (format) {
                    case 'SHORT':
                        return n.substr(2, 6) + sep + n.substr(-4, 4);
                    case 'LONG':
                        return n.substr(0, 8) + sep + n.substr(-4, 4);
                    default:
                        return n;
                }
            }
        };

    $('.js-campaign-loggedin-step-2-form').submit(function () {
        var terms = $('#CampaignSignup_SignupChecked')[0];
        if (terms.checked) {
            $('.js-campaign-loggedin-step-2-button').prop('disabled', true);
            $('.js-campaign-loggedin-step-2-button .loading-spinner-wrapper').css('display', 'block');
        }
    });

    $('.js-campaign-new-step-2-form').submit(function () {
        var terms = $('#CampaignSignup_Step2_SignupPaymentChecked')[0];
        if (terms.checked) {
            $('.js-campaign-new-step-2-button').prop('disabled', true);
            $('.js-campaign-new-step-2-button .loading-spinner-wrapper').css('display', 'block');
        }
    });

    window.kombiApp = window.kombiApp || {};
    window.kombiApp.Components = window.kombiApp.Components || {};
    window.kombiApp.ComponentInstances = window.kombiApp.ComponentInstances || {};

    window.kombiApp.RegisterComponentInstance = function (componentName, componentInstance) {
        if (window.kombiApp.ComponentInstances[componentName]) {
            throw new Error('Component instance already exists');
        }
        window.kombiApp.ComponentInstances[componentName] = componentInstance;
    }

    $(document).ready(app.init);
}(window, document, $, _));
